export default __webpack_public_path__ + "static/media/test-twitter.3316619a.svg";